module.exports = __webpack_public_path__ + "img/165.cb88d672.jpg";